import { lang } from './page';
import { labels as labelsUrl } from './urls';
import { log } from './log';
import { getLangSet } from './langset';

const cache = {};
let mismatch = false;

/**
 * Call the labels API and returns an object keyed by English strings
 * with the value being the same string in the detected browser / user selected
 * language.
 */
export async function labels() {
  const result = cache[lang] || {};

  if (Object.keys(result).length === 0) {
    const data = await getLangSet(labelsUrl, lang);

    data[1].forEach((i, idx) => {
      if (i.Name === data[0][idx]?.Name_en) {
        result[i.Name] = data[0][idx].Name;
      } else {
        result[i.Name] = data[0].find((lbl) => (lang === 'en' ? lbl.Name : lbl.Name_en) === i.Name)?.Name || '';

        if (mismatch === false) {
          mismatch = true;
          log(`Mismatched indexes in labels call in ${lang} for: "${i.Name}"`);
        }
      }
    });
    cache[lang] = result;
  }

  return result;
}

export function getLabel(str, llang = lang) {
  if (cache[llang] !== void 0 && cache[llang][str] !== void 0) {
    return cache[llang][str];
  }

  if (cache[llang] !== void 0 && cache[llang][str] === void 0) {
    log(`Translation not found. Defaulting string "${str}"`);
  } else {
    log(`No label cache found. Defaulting string "${str}"`);
  }

  return str;
}
